import styled from '@emotion/styled';
import { Box, Drawer, MenuItem } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { CSSProperties } from 'react';
import { theme } from '@style/theme';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'left',
  gap: '1rem',
}));

export const StyledDrawer = styled(Drawer)<{ drawerWidth: number }>(
  ({ drawerWidth }) => ({
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      marginTop: '48px',
      zIndex: 10,
    },
  }),
);

export const TransformWrapperContainer = styled(Box)<{
  drawerWidth: number;
  theme: Theme;
}>(({ drawerWidth, theme }) => ({
  flexGrow: 1,
  width: `calc(100% - ${drawerWidth}px)`,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const layoutContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100vh',
  backgroundColor: 'rgb(240,241,245)',
};

export const appBarStyle: CSSProperties = {
  zIndex: 1200,
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  backgroundColor: 'var(--main-color)',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  minHeight: '45px',
};

export const buttonStyle: CSSProperties = {
  marginRight: 1,
  color: 'white !important',
};

export const drawerContainerStyle: CSSProperties = {
  display: 'flex',
  flexGrow: 1,
  marginTop: '48px',
};

export const transformComponentStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  backgroundColor: 'background.default',
};

export const coordinateDisplayStyle: CSSProperties = {
  position: 'absolute',
  top: '80px',
  right: '450px',
  fontSize: '12px',
  width: '100px',
  display: 'flex',
  padding: '0px 20px',
  backgroundColor: 'white',
  borderRadius: 36,
  zIndex: 10,
  border: theme.border.light,
  boxShadow:
    '0px 0px 0px 1px rgba(64, 87, 109, 0.04), 0px 6px 20px -4px rgba(64, 87, 109, 0.3)',
};

export const footerBoxStyle: CSSProperties = {
  position: 'fixed',
  bottom: 0,
  width: '100%',
  backgroundColor: 'background.paper',
  borderTop: 1,
  borderColor: 'divider',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
};

export const alignCenterMaxWidth: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
};
